'use client';
import { Conditional } from '@cat-ecom/pcc-components/src/components/common/conditional';
import React, { FC } from 'react';
import { ProductDealerPriceAvailability } from 'services/dealerPriceAvailability/types';
import { useTranslations } from 'next-intl';
import { CatHeading } from 'components/blocks-components';
import {
  checkIsRiyal,
  getRiyalFormattedPrice
} from 'app/[lang]/[esite]/utils/paymentUtils';

interface FBTPriceProps {
  currency?: string;
  isCatCorp?: boolean;
  partNumber?: string;
  partsPriceData: ProductDealerPriceAvailability[];
  isRTL?: boolean;
  currencyLdFeatureFlag?: boolean;
}

export const findPartData = (
  partNumber: string,
  partsPriceData: ProductDealerPriceAvailability[]
): ProductDealerPriceAvailability => {
  if (!partsPriceData) {
    return;
  }
  return partsPriceData.find((item) => item.partNumber === partNumber);
};

export const getPartPrice = (
  partNumber: string,
  partsPriceData: ProductDealerPriceAvailability[]
): ProductDealerPriceAvailability => {
  return findPartData(partNumber, partsPriceData);
};

export const isInStock = (
  partNumber: string,
  partsPriceData: ProductDealerPriceAvailability[]
): boolean => {
  const partData = findPartData(partNumber, partsPriceData);
  if (!partData?.availability) {
    return false;
  }
  return partData?.availability.some(
    (availabilityItem) => Number(availabilityItem?.quantityAvailable) > 0
  );
};

const FBTPrice: FC<FBTPriceProps> = ({
  currency,
  isCatCorp,
  partNumber,
  partsPriceData,
  isRTL = false,
  currencyLdFeatureFlag = false
}) => {
  const t = useTranslations();
  const partPrice = getPartPrice(partNumber, partsPriceData);
  const inStock = isInStock(partNumber, partsPriceData);
  const isRiyal = currencyLdFeatureFlag && checkIsRiyal(currency);

  return (
    <div>
      {!isCatCorp && (
        <Conditional
          test={partPrice?.enableAddToCart && !!partPrice?.totalPrice}
        >
          <p className={'mt-1 mb-1 ps-0 '}>
            {isRiyal ? (
              getRiyalFormattedPrice({
                price: `${partPrice?.totalPrice} `,
                priceWrapperClasses: 'cat-u-theme-typography-title-sm px-1',
                isRTL: isRTL
              })
            ) : (
              <>
                <span className="cat-u-theme-typography-title-sm">
                  {`${partPrice?.totalPrice} `}
                </span>
                <span className={'cat-u-theme-typography-body'}>
                  {currency}
                </span>
              </>
            )}
          </p>

          <Conditional test={inStock}>
            <CatHeading variant="footnote-bold">
              {t('SHIP_IN_STOCK')}
            </CatHeading>
          </Conditional>
        </Conditional>
      )}
    </div>
  );
};

export default FBTPrice;
